import { useEffect, useState } from 'react'
import { HOURS_IN_BID_TABLE } from '../BidInputTable.types'

export function useRowCount(prefilledRowCount = 0) {
  const [rowCount, setRowCount] = useState(() => Math.max(HOURS_IN_BID_TABLE, prefilledRowCount))

  useEffect(() => {
    setRowCount((prev) => Math.max(prev, prefilledRowCount))
  }, [prefilledRowCount])

  const handleAddRow = () => {
    setRowCount((prev) => prev + 1)
  }

  const handleRemoveLastRow = () => {
    setRowCount((prev) => Math.max(prev - 1, 0))
  }

  return { rowCount, handleAddRow, handleRemoveLastRow }
}
